import { render, staticRenderFns } from "./newbono.vue?vue&type=template&id=4209f5c3&scoped=true"
import script from "./newbono.vue?vue&type=script&lang=js"
export * from "./newbono.vue?vue&type=script&lang=js"
import style0 from "./newbono.vue?vue&type=style&index=0&id=4209f5c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4209f5c3",
  null
  
)

export default component.exports